export const SITE_URL = 'https://www.minware.com';

export const ORG_ID = `${SITE_URL}/#org`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

// Shipped site-wide from Layout so that page-level nodes (e.g. on /pricing)
// can reference these by @id without duplicating them.
export const orgAndWebsiteGraph = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': ORG_ID,
      name: 'minware',
      legalName: 'minware, Inc.',
      url: `${SITE_URL}/`,
    },
    {
      '@type': 'WebSite',
      '@id': WEBSITE_ID,
      url: `${SITE_URL}/`,
      name: 'minware',
      publisher: { '@id': ORG_ID },
      inLanguage: 'en',
    },
  ],
};
